// src/components/Contact.js
import React from "react";
import { motion } from "framer-motion";

const Contact = () => (
  <motion.section
    className="section"
    id="contact"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    <h2>Contact Us</h2>
    <form name="contact" method="POST" data-netlify="true">
      <input type="hidden" name="form-name" value="contact" />
      <input type="text" name="name" placeholder="Your Name" required />
      <input type="email" name="email" placeholder="Your Email" required />
      <textarea name="message" placeholder="Your Message" rows="5" required />
      <button type="submit">Send</button>
    </form>
  </motion.section>
);

export default Contact;
